import { useEffect, useState } from 'react';
import { OrganizationApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { SettingsDto } from '../../../commonTypes/organization.types';

const useHttpGetOrganizationSettings = () => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const [isReady, setIsReady] = useState(false);
    const [data, setData] = useState<SettingsDto>();

    const { exec, abort } = organizationApi.getSettings({
        onSuccess: res => {
            setData(res.body);
        },
        onError: error => console.error(error),
        onFinally: () => setIsReady(true),
    });

    useEffect(() => {
        exec();
        return abort;
    }, []);

    return { exec, isReady, data };
};

export default useHttpGetOrganizationSettings;
